import {
  HangzhouApplicationController,
  KunshanApplicationController,
  WuxiApplicationController,
  CourseCenterApplicationController,
} from '@/services/request.service';

import CommonDetail from '@/views/StudentDetail/components/CommonDetail.vue';
import CourseCenterDetail from '@/views/StudentDetail/components/CourseCenterDetail.vue';

import WXStep1 from '@/views/ApplicationForm/components/wuxi/Step1.vue';
import WXStep2 from '@/views/ApplicationForm/components/wuxi/Step2.vue';
import WXStep3 from '@/views/ApplicationForm/components/wuxi/Step3.vue';
import KSStep1 from '@/views/ApplicationForm/components/kunshan/Step1.vue';
import KSStep2 from '@/views/ApplicationForm/components/kunshan/Step2.vue';
import KSStep3 from '@/views/ApplicationForm/components/kunshan/Step3.vue';
import HZStep1 from '@/views/ApplicationForm/components/hangzhou/Step1.vue';
import HZStep2 from '@/views/ApplicationForm/components/hangzhou/Step2.vue';
import HZStep3 from '@/views/ApplicationForm/components/hangzhou/Step3.vue';
import SXStep1 from '@/views/ApplicationForm/components/courseCenter/Step1.vue';
import SXStep2 from '@/views/ApplicationForm/components/courseCenter/Step2.vue';

export default {
  // 测试国际学校
  IntApply: {
    schoolId: 4,
    schoolName: 'IntSchool',
    schoolEnName: 'IntSchool',
    shortName: '入学申请',
    QRCode: `ksQRCode.jpg`,
    showSchoolExtra: true,
    showFormIntFlag: true,
    isShowUniform: true,
    isShowEnterYear: true,
    isShowEnglishLevel: true,
    isShowInterest: true,
    isShowAchievement: true,
    isShowIdNumber: false,
    isShowHighestEducation: true,
    isShowGraduatedSchool: true,
    isShowWorkAddress: false,
    isShowFirstContact: true,
    isShowCensus: true,
    censusRequired: true,
    isCourseCenter: false,
    showApplyGradeFlag: true,
    showCurrentSection: true,
    isChineseEnNameRequired: false,
    showResourceExtraValue: [1322, 1327, 1328, 1323, 1330],
    defaultOneParent: false, // 默认只有一个家长
    controller: KunshanApplicationController,
    detailPage: CommonDetail,
    form: [KSStep1, KSStep2, KSStep3],
    upload: [
      { fileType: 84, fileName: 'file1', description: 'file1Tip' },
      { fileType: 85, fileName: 'file2', description: '' },
      { fileType: 86, fileName: 'file3', description: '' },
      { fileType: 87, fileName: 'file4', description: 'file4Tip' },
      { fileType: 88, fileName: 'file5', description: 'file5Tip' },
    ],
    enquiryTip: '感谢您的关注，如果您有任何疑问，请填写表格留下联系方式，我们会尽快联系您',
    enquiryTipEn:
      'Thank you for your attention. If you have any questions, please fill in the form and leave your contact information. We will contact you as soon as possible.',
    location: [{
      road: {
        schoolName: '入学申请',
        schoolEnName: '入学申请', value: '江苏省南京市长江路188号',
        enValue: 'No. 188 Changjiang Road, Nanjing City, Jiangsu Province',
      },
      city: {
        value: '南京 215300',
        enValue: 'Nanjing 215300',
      },
      country: {
        value: '中国',
        enValue: 'China',
      },
      mobile: '025-57924570',
      email: 'admissions@enhertz.com',
      website: 'www.enhertz.com',
    }],
    wechat: false, // 是否启用微信跳转获取用户openid
  },
 
};
